const Show = ({ when, fallback, children }) => {
  return when ? (typeof children === 'function' ? children(when) : children) : fallback;
};

export default Show;
